import { render, staticRenderFns } from "./DashboardProponente.vue?vue&type=template&id=0fa18dec&"
import script from "./DashboardProponente.vue?vue&type=script&lang=js&"
export * from "./DashboardProponente.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProponente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports